import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

import useAnimate from './primitives/Motion';

import ScrollLitText from './primitives/ScrollLitText';
import { manifesto } from '../data/site';

export default function Manifesto() {
    const ref = useRef(null);
    const reduced = !useAnimate();

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end start']
    });

    const glowOpacity = useTransform(scrollYProgress, [0.1, 0.5, 0.9], [0, 0.55, 0]);
    const eyebrowY = useTransform(scrollYProgress, [0, 1], ['30%', '-30%']);

    return (
        <section className="manifesto" id="manifesto" ref={ref}>
            <div className="manifesto__pin">
                <motion.div
                    className="manifesto__glow"
                    style={reduced ? undefined : { opacity: glowOpacity }}
                    aria-hidden="true"
                />

                <div className="shell manifesto__body">
                    <motion.span
                        className="t-eyebrow manifesto__eyebrow"
                        style={reduced ? undefined : { y: eyebrowY }}
                    >
                        The group
                    </motion.span>

                    <ScrollLitText className="manifesto__text" text={manifesto} targetRef={ref} />
                </div>
            </div>
        </section>
    );
}
